export default __webpack_public_path__ + "static/media/avanish.3e51a5ee.png";